import React, { type ReactNode, ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "../../utils/constants";
import useAuth from "../../hooks/useAuth";

interface ProtectedRouteProps {
  children: ReactNode;
  redirectPath?: string;
}
const defaultRedirectPath = ROUTES.ROOT.LOG_IN;

function ProtectedRoute({
  children,
  redirectPath = defaultRedirectPath,
}: ProtectedRouteProps): ReactElement {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}

export { ProtectedRoute };
